import wifiAnimation from '../../assets/icons/wifi-animation.svg';
import './ReconnectModal.scss';
import { useTranslation } from '../../platform/stores';


export const showReconnectingModal = () => {
  const el = document.getElementById('reconnectingModal');
  if (el) {
    el.style.display = 'flex';
  }
};

export const hideReconnectingModal = () => {
  const el = document.getElementById('reconnectingModal');
  if (el) {
    el.style.display = 'none';
  }
};

export const ReconnectingModal = () => {
  const t = useTranslation();
  return (
    <div id="reconnectingModal">
      <div className="content">
        <img src={wifiAnimation} alt="WiFi icon"/>
        <div id="reconnectingText">
          {t('RECONNECTING')}
        </div>
      </div>
    </div>
  );
}
